import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { GridDirective } from './grid/grid.directive';
import { GridComponent } from './grid/grid.component';
import { GridEventService } from './grid/services/grid-event.service';
import { GridFactory } from './grid/services/grid.service';
import { GridSaveFactoryService } from './grid/services/grid-save-factory.service';
import { GridValidationFactoryService } from './grid/services/grid-validation-factory.service';
import { GridCellAuditService } from './grid/services/grid-cell-audit.service';
import { CeHostDialogComponent } from '../shared/components/ce-host-dialog/ce-host-dialog.component';
import { SimpleConfirmDialogComponent } from '../shared/components/simple-confirm-dialog/simple-confirm-dialog.component';

@NgModule({ declarations: [
        GridDirective,
        GridComponent,
        CeHostDialogComponent,
        SimpleConfirmDialogComponent],
    exports: [
        GridDirective,
        GridComponent], imports: [CommonModule,
        MatDialogModule,
        MatSnackBarModule], providers: [
        GridEventService,
        GridFactory,
        GridSaveFactoryService,
        GridValidationFactoryService,
        GridCellAuditService] })
export class CoreModule {}
